import Model from '../Model'
import moment from "moment";

export default class Estimate extends Model {

    getDownloadUrl() {

        return route('api.v2.external.estimates.pdf', [this.id]) + '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
    }

    getDownloadXLSXUrl() {
        return route('api.v2.external.estimates.xlsx', [this.id]) + '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
    }

    getPrintableUrl() {
        return route('api.v2.external.estimates.download', [this.id]) + '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
    }

    static async find(id) {
        const data = await Http.get(route('api.v2.external.estimates', id))
        return this.make(data);
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [
            this.formattedDate,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static async all() {
        const params = {}
        const data = await Http.get(route('api.v2.external.estimates.list'), {params})
        return this.make(data)
    }

    async markViewed(id) {
        const data = await Http.post(route('api.v2.external.estimates.viewed', id))
    }
}
